import React from 'react';
import Navbar from '../Home/Navbar';
import Footer from '../Home/Footer';
import CookieBanner from '../legal/CookieBanner';


// Layout Component is the standart component for all pages with includes Navbar and Footer

const Layout = ({ children, hideFooter = false }) => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-16 sm:pt-20">
        {children}
      </main>
      {!hideFooter && (
        <Footer />
      )}
      <CookieBanner />
    </div>
  );
};

export default Layout; 
